import React from 'react';
import styled from 'styled-components';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CategoriesContainer = styled.section`
  padding: 80px 0;
  background: white;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 60px;

  h2 {
    font-size: 2.5rem;
    font-weight: 300;
    color: #2c2c2c;
    margin-bottom: 20px;
  }

  p {
    font-size: 1.1rem;
    color: #666;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.6;
  }
`;

const CategoriesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
`;

const CategoryItem = styled.div<{ $bgImage: string }>`
  position: relative;
  height: 400px;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  background-image: url(${props => props.$bgImage});
  background-size: cover;
  background-position: center;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 50%);
  }
`;

const CategoryContent = styled.div`
  position: relative;
  z-index: 1;
  padding: 30px;
  color: #fff;
  width: 100%;
`;

const CategoryTitle = styled.h3`
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 10px;
`;

const CategorySubtitle = styled.p`
  font-size: 1rem;
  margin-bottom: 20px;
  opacity: 0.8;
`;

const CategoryButton = styled.button`
  background: #fff;
  color: #333;
  border: none;
  padding: 12px 25px;
  border-radius: 30px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: #f0f0f0;
    transform: translateX(5px);
  }
`;

const ProductCategoriesSection: React.FC = () => {
  const navigate = useNavigate();

  const categories = [
    {
      id: 1,
      title: 'GELİNLİK',
      subtitle: 'Hayalinizdeki gelinlikler',
      image: '/pictures/gelinlik/gelinlik-kucuk.webp',
      path: '/gelinlikler'
    },
    {
      id: 2,
      title: 'ABİYE',
      subtitle: 'Şık ve zarif tasarımlar',
      image: '/pictures/abiye/abiye-kucuk.webp',
      path: '/abiyeler'
    },
    {
      id: 3,
      title: 'KINANLIK',
      subtitle: 'Özel kına geceniz için',
      image: '/pictures/kinalik/kinalik-kucuk.webp',
      path: '/kinaliklar'
    },
    {
      id: 4,
      title: 'AKSESUAR',
      subtitle: 'Mükemmelliği tamamlayan detaylar',
      image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
      path: '/aksesuar'
    }
  ];

  const handleCategoryClick = (path: string) => {
    navigate(path);
  };

  return (
    <CategoriesContainer>
      <Container>
        <SectionHeader>
          <h2>Ürün Kategorileri</h2>
          <p>Hayalinizdeki özel gün için geniş ürün yelpazemizi keşfedin.</p>
        </SectionHeader>
        <CategoriesGrid>
          {categories.map((category) => (
            <CategoryItem
              key={category.id}
              $bgImage={category.image}
              onClick={() => handleCategoryClick(category.path)}
            >
              <CategoryContent>
                <CategoryTitle>{category.title}</CategoryTitle>
                <CategorySubtitle>{category.subtitle}</CategorySubtitle>
                <CategoryButton>
                  Keşfet
                  <ArrowRight size={16} />
                </CategoryButton>
              </CategoryContent>
            </CategoryItem>
          ))}
        </CategoriesGrid>
      </Container>
    </CategoriesContainer>
  );
};

export default ProductCategoriesSection;
